import CredReqEventStatus, { CredReqEventStatusLabel } from '$shared/constants/CredReqEventStatus';
import { CvoAdditionalInfoRequestedStatusList } from '$shared/constants/CredReqEventStatus';
import type { ICredReqEvent } from '$shared/interfaces/api/ICredReqEvent';
import type { ICredReqEventAttachment } from '$shared/interfaces/api/ICredReqEventAttachment';
import DateString from '$shared/models/DateString';
import CredReqEventAttachment from './CredReqEventAttachment';
import CredReqEventUser from './CredReqEventUser';

export default class CredReqEvent {
  public id: string;
  public status: CredReqEventStatus;
  public description: string;
  public note: string;
  public timestamp: DateString;
  public user: CredReqEventUser;
  public attachments?: CredReqEventAttachment[];

  public get isReview(): boolean {
    return CvoAdditionalInfoRequestedStatusList.includes(this.status);
  }

  public get isCompleted(): boolean {
    return [CredReqEventStatus.Completed, CredReqEventStatus.CompletedWithConcern].includes(
      this.status
    );
  }

  public get transcationDetails(): string {
    return [this.parsedTimestamp, this.userEmail].filter(Boolean).join(', ') || '';
  }

  public get parsedStatus(): string {
    return CredReqEventStatusLabel[this.status];
  }

  public get parsedTimestamp(): string {
    return this.timestamp.getLocalizedDateAndTime();
  }

  public get userEmail(): string {
    return this.user?.email || '';
  }

  constructor(response: ICredReqEvent) {
    if (!response) {
      return;
    }
    this.id = response.id;
    this.status = response.status;
    this.description = response.description;
    this.note = response.note;
    this.timestamp = new DateString(response.timestamp);
    this.user = new CredReqEventUser(response.user);
    this.attachments =
      response.attachments?.map(
        (attachment: ICredReqEventAttachment) => new CredReqEventAttachment(attachment)
      ) || [];
  }
}
